import { useAppDispatch } from '@store/store';
import {
  addChildToNode,
  insertInPlaceAndReparent,
  insertSiblingAbove,
  insertSiblingBelow,
} from '@store/rca-editor/rca-editor-actions';
import { BaseNodeState } from '@pages/app/rca/tabs/components/node-types/default-node-hook';

export default function useNodeAction(state: BaseNodeState) {
  const { id, isRoot, isConnection, isEndStateOrConnection } = state;

  const dispatch = useAppDispatch();

  const canAddLeft = !isRoot && !isConnection;
  const canAddRight = !isEndStateOrConnection;

  const addSiblingAbove = () => {
    dispatch(insertSiblingAbove(id));
  };

  const addSiblingBelow = () => {
    dispatch(insertSiblingBelow(id));
  };

  const addChild = () => {
    dispatch(addChildToNode(id));
  };

  const insertInPlace = () => {
    dispatch(insertInPlaceAndReparent(id));
  };

  return {
    canAddLeft,
    canAddRight,
    addSiblingAbove,
    addSiblingBelow,
    addChild,
    insertInPlace,
  };
}
